export default "__VITE_ASSET__Bui8$_4v__"